import styled, { css } from 'styled-components';

export const TableColStyled = styled.td`
  ${({ vAlign, borderTypeColor, maxWidth }) => css`
    vertical-align: ${vAlign};
    border-left: ${borderTypeColor};
    width: ${maxWidth};
  `}
`;
